import React from 'react';

import CustomTd from '../shared/table/CustomTd';
import formatter from '../../utilities/formatter'

const MiscSaleReportItem = ({ item, totalRow }) => {
    return (totalRow ?
        (
            <tr className='total-row'>
                <td>
                    TOTAL
                </td>
                <td colSpan={2}></td>
                <td>
                    {formatter.currency(item.total)}
                </td>
                <td>
                    {formatter.currency(item.deposit)}
                </td>
                <td colSpan={2}></td>
                <td>
                    {formatter.currency(item.balanceDue)}
                </td>
                <td colSpan={4}></td>
            </tr>
        ) : (
            <tr>
                <CustomTd>
                    {formatter.date(item.dateEntered)}
                </CustomTd >
                <CustomTd>
                    {item.customerName}
                </CustomTd>
                <CustomTd>
                    {item.designer}
                </CustomTd>
                <CustomTd>
                    {formatter.currency(item.total)}
                </CustomTd>
                <CustomTd>
                    {formatter.currency(item.deposit)}
                </CustomTd>
                <CustomTd>
                    {item.depositType && item.depositType === '0' ? '' : item.depositType.replace('_', ' ')}
                </CustomTd>
                <CustomTd>
                    {formatter.date(item.dateDeposit)}
                </CustomTd>
                <CustomTd>
                    {formatter.currency(item.balanceDue)}
                </CustomTd>
                <CustomTd>
                    {item.paidInFull ? '✓' : ''}
                </CustomTd>
                <CustomTd>
                    {formatter.date(item.dateBalancePaid)}
                </CustomTd>
                <CustomTd colSpan={2}>
                    {item.description}
                </CustomTd>
            </tr>
        )
    );
}

MiscSaleReportItem.defaultProps = {
    totalRow: false
}

export default MiscSaleReportItem;